
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38.2 38.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.1.5A18.6 18.6 0 11.5 19.1 18.6 18.6 0 0119.1.5z","fill":"none","stroke":"#ffa635","stroke-dasharray":"3 2"}}),_c('circle',{attrs:{"cx":"14.7","cy":"23.5","r":"6.25","fill":"#ffa635"}}),_c('path',{attrs:{"d":"M19.06 12.89a6.26 6.26 0 00-5.73 3.75 6.84 6.84 0 011.37-.14 7 7 0 017 7 6.84 6.84 0 01-.14 1.37 6.25 6.25 0 00-2.5-12z","fill":"#ffa635"}}),_c('path',{attrs:{"d":"M23.5 8.45a6.25 6.25 0 00-5.76 3.82 7.2 7.2 0 011.32-.13 7 7 0 017 7 7.2 7.2 0 01-.13 1.32 6.25 6.25 0 00-2.43-12z","fill":"#ffa635"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/network/mdu.svg